import L from 'leaflet';
import 'protomaps-leaflet';
import {exp} from "protomaps-leaflet";

export const leafletVectorUtils = {

    methods: {
        createCustomProtomapsLayer(url, authHeader, options) {
            // Extend L.protomaps to create a custom layer
            const CustomProtomapsLayer =  L.protomaps.extend({
                createTile: function (coords, done) {
                    const tile = document.createElement('canvas');
                    tile.width = this.getTileSize().x;
                    tile.height = this.getTileSize().y;

                    const tileUrl = L.Util.template(url, coords);

                    // Custom XMLHttpRequest to add headers
                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', tileUrl, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.setRequestHeader('Authorization', authHeader);

                    xhr.onload = function () {
                        if (xhr.status >= 200 && xhr.status < 300) {
                             done(null, tile);
                        } else {
                            // eslint-disable-next-line
                            console.error(`Tile request failed: ${xhr.status}`);
                            done(new Error(`Tile request failed: ${xhr.statusText}`), tile);
                        }
                    }.bind(this);

                    xhr.onerror = function () {
                        // eslint-disable-next-line
                        console.error('Error loading tile');
                        done(new Error('Error loading tile'), tile);
                    };

                    xhr.send();

                    return tile;
                },
            })
            // Return an instance of the custom layer with the passed options
            return new CustomProtomapsLayer({
                ...options, // Merge provided options
            });
        },

        /* eslint-disable*/
        getPaintRules() {
            return [
                // WATER
                {
                    dataLayer: "water",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#BEE4FD",
                        stroke: "#BEE4FD",
                        opacity: 0.8,
                        width: 2
                    })
                },
                // BUILDING
                {
                    dataLayer: "building",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#eeebdb",
                        stroke: "#c9c6ba",
                        opacity: 1,
                        width: 1
                    })
                },
                // LANDUSE
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#fcf5e1",
                        opacity: 0.0
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["residential"].includes(kind);
                    },
                },
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#f3fca2",
                        opacity: 0.6
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["farmland"].includes(kind);
                    },
                },
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#ebf8d1",
                        opacity: 0.6
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["park", "pitch"].includes(kind);
                    },
                },
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#EAF2F2",
                        opacity: 0.3
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["school"].includes(kind);
                    },
                },
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#f3f2f1",
                        opacity: 0.6
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["industrial", "commercial", "retail"].includes(kind);
                    },
                },
                // LANDCOVER
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#dff1cc",
                        opacity: 0.6
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["grass", "scrubb"].includes(kind);
                    },
                },
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#BEE4FD",
                        opacity: 0.7
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["wetland"].includes(kind);
                    },
                },
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#dceebd",
                        opacity: 0.6
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["forest", "wood"].includes(kind);
                    },
                },
                // ROADS
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        fill: "#000000",
                        opacity: 0.3,
                        dash: [2, 2],
                        dashColor: "#000000",
                        dashWidth: 2
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["rail"].includes(kind);
                    },
                },

                // Outline for motorways
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#c50505",
                        opacity: 1,
                        width: (z, f) => {
                            return exp(2.2, [
                                [13, 4.2],
                                [19, 6.2],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["motorway"].includes(kind)
                    },
                },

                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#e38a5a",
                        opacity: 1,
                        lineCap: 'round',
                        lineJoin: 'round',
                        width: (z, f) => {
                            return exp(1.6, [
                                [13, 3],
                                [19, 5],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["motorway"].includes(kind)
                    },
                },

                // Outline for trunks - same width as upper class
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#e38a5a",
                        opacity: 1,
                        width: (z, f) => {
                            return exp(1.3, [
                                [13, 4.2],
                                [19, 6.2],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["trunk", "primary"].includes(kind)
                    },
                },
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#f3da20",
                        opacity: 1,
                        lineCap: 'round',
                        lineJoin: 'round',
                        width: (z, f) => {
                            return exp(1.6, [
                                [11, 1],
                                [13, 3],
                                [19, 5],
                            ])(z)
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["trunk", "primary"].includes(kind)
                    },
                },

                // Outline for secondary
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#9f9d9d",
                        opacity: 1,
                        width: (z, f) => {
                            return exp(2.2, [
                                [14, 3.2],
                                [16, 4.2],
                                [18, 5.2]
                            ])(z)
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["secondary", "tertiary"].includes(kind)
                    },
                },
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#ffffff",
                        opacity: 1,
                        lineCap: 'round',
                        lineJoin: 'round',
                        width: (z, f) => {
                            return exp(1, [
                                [14, 2],
                                [16, 3],
                                [18, 4],
                            ])(z)
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["secondary", "tertiary"].includes(kind)
                    },
                },
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#c7c6c6",
                        opacity: 1,
                        width: (z, f) => {
                            return exp(1, [
                                [14, 1],
                                [18, 3],
                            ])(z)
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : ""
                        return ["minor", "cycleway", "service"].includes(kind)
                    },
                },
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#b6977e",
                        opacity: 1,
                        dash: [2, 2],
                        dashColor: "#b6977e",
                        dashWidth: 2,
                        width: 1
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["path"].includes(kind);
                    },
                },
                {
                    dataLayer: "boundary",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#dc5454",
                        opacity: 0.8,
                        dash: [2, 2],
                        dashColor: "#dc5454",
                        dashWidth: 1,
                        width: 1
                    }),
                    filter: (z, f) => {
                        return z < 14
                    }
                },
                {
                    dataLayer: "boundary",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#c0bfbf",
                        opacity: 0.8,
                        dashColor: "#c0bfbf",
                        dashWidth: 1,
                        dash: [2,2],
                        width: 1
                    }),
                    filter: (z, f) => {
                        return z >= 14
                    }
                },
            ]
        },

        getLabelRules() {
            return [
                // PLACES
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "white",
                        width: 1,
                        letterSpacing: 4,
                        stroke: "#a2a2a2",
                        font: "400 16px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["country"].includes(kind);
                    }
                },
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#404041",
                        width: 1,
                        letterSpacing: 2,
                        stroke: "#ffffffff",
                        font: "600 16px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["city"].includes(kind);
                    }
                },
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#404041",
                        stroke: "#ffffff",
                        width: 1,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["town"].includes(kind);
                    }
                },
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        textTransform: 'uppercase',
                        fill: "#404041",
                        stroke: "#ffffff",
                        width: 1,
                        font: "400 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = z < 12 && f.props.class ? f.props.class : ""
                        return ["suburb", "village", "quarter", "hamlet", "neighbourhood"].includes(kind)
                    }
                },
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        textTransform: 'uppercase',
                        fill: "#404041",
                        stroke: "#ffffff",
                        width: 1,
                        font: "400 14px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = z > 11 && f.props.class ? f.props.class : ""
                        return ["suburb", "village", "quarter", "hamlet", "neighbourhood"].includes(kind)
                    }
                },
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#7b7b80",
                        stroke: "#ffffff",
                        width: 1,
                        font: "400 11px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["peak"].includes(kind);
                    }
                },
                {
                    dataLayer: "water_name",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#0571ce",
                        stroke: "#ffffff",
                        width: 1,
                        font: "400 10px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["bay", "river"].includes(kind);
                    }
                },
                {
                    dataLayer: "water_name",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#0571ce",
                        stroke: "#ffffff",
                        width: 1,
                        font: "400 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["lake", "ocean", "sea"].includes(kind);
                    }
                },
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.LineLabelSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#000000",
                        stroke: "#ffffff",
                        width: 1,
                        position: 2,
                        font: "400 12px sans-serif"
                    })
                },
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1
                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.replaceAll(";", " ")
                                return ['roadNum']
                            }
                            return ['ref']
                        },
                        fill: "#ffffff",
                        stroke: "#ffffff",
                        background: "#e70505",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        // Don't draw all of them
                        let id = parseInt(f.props.id.substring(f.props.id.indexOf("/")+1))
                        if (id % 21 !== 0) return false;
                        const kind = f.props.class ? f.props.class : "";
                        return ["motorway", "trunk"].includes(kind);
                    }
                },
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1
                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.substring(0, index)
                                return ['roadNum']
                            }
                            return ['ref']
                        },
                        fill: "#000000",
                        stroke: "#000000",
                        background: "#ffffff",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        let id = parseInt(f.props.id.substring(f.props.id.indexOf("/")+1))
                        if (id % 11 !== 0) return false;
                        const kind = f.props.class ? f.props.class : "";
                        return ["primary"].includes(kind);
                    }
                },
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1
                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.substring(0, index)
                                return ['roadNum']
                            }
                            return ['ref']
                        },
                        fill: "#000000",
                        stroke: "#000000",
                        background: "#ffffff",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        let id = parseInt(f.props.id.substring(f.props.id.indexOf("/")+1))
                        if (id % 3 !== 0) return false;
                        const kind = f.props.class ? f.props.class : "";
                        return ["secondary"].includes(kind);
                    }
                },
            ]
        },

        getDarkPaintRules() {
            return [
                // WATER
                {
                    dataLayer: "water",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#667478",
                        stroke: "#667478",
                        opacity: 1,
                        width: 1
                    })
                },

                // BUILDING
                {
                    dataLayer: "building",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#747776",
                        stroke: "#686D6B",
                        opacity: 1,
                        width: 1
                    })
                },

                // LANDUSE - RESIDENTIAL
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#6A6F6D",
                        opacity: 0.65
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["residential"].includes(kind);
                    },
                },

                // FARMLAND
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#73766B",
                        opacity: 0.65
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["farmland"].includes(kind);
                    },
                },

                // PARK / PITCH
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#657267",
                        opacity: 0.7
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["park", "pitch"].includes(kind);
                    },
                },

                // SCHOOL
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#727574",
                        opacity: 0.65
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["school"].includes(kind);
                    },
                },

                // INDUSTRIAL / COMMERCIAL / RETAIL
                {
                    dataLayer: "landuse",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#747574",
                        opacity: 0.7
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["industrial", "commercial", "retail"].includes(kind);
                    },
                },

                // GRASS / SCRUB
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#687369",
                        opacity: 0.65
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["grass", "scrubb"].includes(kind);
                    },
                },

                // WETLAND
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#637171",
                        opacity: 0.7
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["wetland"].includes(kind);
                    },
                },

                // FOREST / WOOD
                {
                    dataLayer: "landcover",
                    symbolizer: new protomapsL.PolygonSymbolizer({
                        fill: "#59655D",
                        opacity: 0.8
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["forest", "wood"].includes(kind);
                    },
                },

                // RAIL
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#555B59",
                        opacity: 0.7,
                        dash: [2, 2],
                        dashColor: "#555B59",
                        dashWidth: 2
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["rail"].includes(kind);
                    },
                },

                // MOTORWAY OUTLINE
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#555957",
                        opacity: 0.9,
                        width: (z, f) => {
                            return exp(2.2, [
                                [13, 4.2],
                                [19, 6.2],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["motorway"].includes(kind);
                    },
                },

                // MOTORWAY
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#858782",
                        opacity: 0.95,
                        lineCap: "round",
                        lineJoin: "round",
                        width: (z, f) => {
                            return exp(1.6, [
                                [13, 3],
                                [19, 5],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["motorway"].includes(kind);
                    },
                },

                // TRUNK / PRIMARY OUTLINE
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#595C58",
                        opacity: 0.9,
                        width: (z, f) => {
                            return exp(1.3, [
                                [13, 4.2],
                                [19, 6.2],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["trunk", "primary"].includes(kind);
                    },
                },

                // TRUNK / PRIMARY
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#7B7D74",
                        opacity: 0.95,
                        lineCap: "round",
                        lineJoin: "round",
                        width: (z, f) => {
                            return exp(1.6, [
                                [11, 1],
                                [13, 3],
                                [19, 5],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["trunk", "primary"].includes(kind);
                    },
                },

                // SECONDARY / TERTIARY OUTLINE
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#595E5C",
                        opacity: 0.85,
                        width: (z, f) => {
                            return exp(2.2, [
                                [14, 3.2],
                                [16, 4.2],
                                [18, 5.2]
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["secondary", "tertiary"].includes(kind);
                    },
                },

                // SECONDARY / TERTIARY
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#777C79",
                        opacity: 0.9,
                        lineCap: "round",
                        lineJoin: "round",
                        width: (z, f) => {
                            return exp(1, [
                                [14, 2],
                                [16, 3],
                                [18, 4],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["secondary", "tertiary"].includes(kind);
                    },
                },

                // MINOR / CYCLEWAY / SERVICE
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#737976",
                        opacity: 0.75,
                        width: (z, f) => {
                            return exp(1, [
                                [14, 1],
                                [18, 3],
                            ])(z);
                        }
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["minor", "cycleway", "service"].includes(kind);
                    },
                },

                // PATH
                {
                    dataLayer: "transportation",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#696F6C",
                        opacity: 0.7,
                        dash: [2, 2],
                        dashColor: "#696F6C",
                        dashWidth: 2,
                        width: 1
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["path"].includes(kind);
                    },
                },

                // BOUNDARY
                {
                    dataLayer: "boundary",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#515755",
                        opacity: 0.65,
                        dash: [2, 2],
                        dashColor: "#515755",
                        dashWidth: 1,
                        width: 1
                    }),
                    filter: (z, f) => z < 14
                },

                {
                    dataLayer: "boundary",
                    symbolizer: new protomapsL.LineSymbolizer({
                        color: "#626865",
                        opacity: 0.6,
                        dashColor: "#626865",
                        dashWidth: 1,
                        dash: [2, 2],
                        width: 1
                    }),
                    filter: (z, f) => z >= 14
                },
            ];
        },

        getDarkLabelRules() {
            return [
                // COUNTRY
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#303432",
                        width: 1,
                        letterSpacing: 4,
                        stroke: "#777C79",
                        font: "400 16px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["country"].includes(kind);
                    }
                },

                // CITY
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#303432",
                        width: 1,
                        letterSpacing: 2,
                        stroke: "#777C79",
                        font: "600 16px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["city"].includes(kind);
                    }
                },

                // TOWN
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#343836",
                        stroke: "#777C79",
                        width: 1,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["town"].includes(kind);
                    }
                },

                // SMALL PLACES
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        textTransform: "uppercase",
                        fill: "#3C403E",
                        stroke: "#777C79",
                        width: 1,
                        font: "400 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = z < 12 && f.props.class ? f.props.class : "";
                        return ["suburb", "village", "quarter", "hamlet", "neighbourhood"].includes(kind);
                    }
                },

                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        textTransform: "uppercase",
                        fill: "#393D3B",
                        stroke: "#777C79",
                        width: 1,
                        font: "400 14px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = z > 11 && f.props.class ? f.props.class : "";
                        return ["suburb", "village", "quarter", "hamlet", "neighbourhood"].includes(kind);
                    }
                },

                // PEAK
                {
                    dataLayer: "place",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#444947",
                        stroke: "#777C79",
                        width: 1,
                        font: "400 11px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["peak"].includes(kind);
                    }
                },

                // WATER NAMES
                {
                    dataLayer: "water_name",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#505E61",
                        stroke: "#778184",
                        width: 1,
                        font: "400 10px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["bay", "river"].includes(kind);
                    }
                },

                {
                    dataLayer: "water_name",
                    symbolizer: new protomapsL.CenteredTextSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#505E61",
                        stroke: "#778184",
                        width: 1,
                        font: "400 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        const kind = f.props.class ? f.props.class : "";
                        return ["lake", "ocean", "sea"].includes(kind);
                    }
                },

                // ROAD NAMES
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.LineLabelSymbolizer({
                        labelProps: ['name:latin', 'name:nonlatin'],
                        fill: "#343836",
                        stroke: "#858A87",
                        width: 1,
                        position: 2,
                        font: "400 12px sans-serif"
                    })
                },

                // MOTORWAY / TRUNK SHIELDS
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1;

                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.replaceAll(";", " ");
                                return ['roadNum'];
                            }

                            return ['ref'];
                        },
                        fill: "#353937",
                        stroke: "#555A58",
                        background: "#929693",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        let id = parseInt(
                            f.props.id.substring(f.props.id.indexOf("/") + 1)
                        );

                        if (id % 21 !== 0) return false;

                        const kind = f.props.class ? f.props.class : "";
                        return ["motorway", "trunk"].includes(kind);
                    }
                },

                // PRIMARY SHIELDS
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1;

                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.substring(0, index);
                                return ['roadNum'];
                            }

                            return ['ref'];
                        },
                        fill: "#353937",
                        stroke: "#555A58",
                        background: "#969A97",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        let id = parseInt(
                            f.props.id.substring(f.props.id.indexOf("/") + 1)
                        );

                        if (id % 11 !== 0) return false;

                        const kind = f.props.class ? f.props.class : "";
                        return ["primary"].includes(kind);
                    }
                },

                // SECONDARY SHIELDS
                {
                    dataLayer: "transportation_name",
                    symbolizer: new protomapsL.ShieldSymbolizer({
                        labelProps: (z, f) => {
                            let index = f.props && f.props.ref ? f.props.ref.indexOf(';') : -1;

                            if (index > 0) {
                                f.props['roadNum'] = f.props.ref.substring(0, index);
                                return ['roadNum'];
                            }

                            return ['ref'];
                        },
                        fill: "#353937",
                        stroke: "#555A58",
                        background: "#969A97",
                        padding: 2,
                        width: 1,
                        position: 2,
                        font: "600 12px sans-serif"
                    }),
                    filter: (z, f) => {
                        let id = parseInt(
                            f.props.id.substring(f.props.id.indexOf("/") + 1)
                        );

                        if (id % 3 !== 0) return false;

                        const kind = f.props.class ? f.props.class : "";
                        return ["secondary"].includes(kind);
                    }
                },
            ];
        }
    }
}

